import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';
import { GenericErrorComponent } from './generic-error.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [ GenericErrorComponent ],
    declarations: [ GenericErrorComponent ],
    entryComponents: [ GenericErrorComponent ],
})
export class GenericErrorModule {}
